/* Everest VW: DUDU7 step-by-step builder (Get You Booked, Oct 2026).
   Renders into snippets/ev-dudu7-builder.liquid. Every priced choice is a variant of the hidden
   product "dudu7-build-options", found by SKU. One Add to basket posts every line to /cart/add.js. */
(function () {
  'use strict';

  var root = document.querySelector('[data-evb="dudu7"]');
  if (!root) return;
  var cfgEl = root.querySelector('[data-evb-config]');
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var OPT = CFG.options || {};
  var MAIN = CFG.main;

  // ---------- data ----------
  var VEHICLES = [
    { key: 'T5', name: 'VW T5', sub: '2003 to 2009', kit: 'DUDU7-KIT-T5', code: '_T5', big: false },
    { key: 'T51', name: 'VW T5.1', sub: '2010 to 2015', kit: 'DUDU7-KIT-T5.1PQ', code: '_T5.1PQ', big: true, quadlock: true },
    { key: 'T6', name: 'VW T6', sub: '2015 to 2020', kit: 'DUDU7-KIT-T6', code: '_T6', big: true },
    { key: 'T61', name: 'VW T6.1', sub: '2020 to 2025', kit: 'DUDU7-KIT-T6.1', code: '_T6.1', big: true, sos: true },
    { key: 'CRA', name: 'VW Crafter', sub: 'Including MAN TGE', kit: 'DUDU7-KIT-CRA', code: '_CRA', big: true, sos: true },
    { key: 'CAD', name: 'VW Caddy', sub: '', kit: 'DUDU7-KIT-CAD', code: '_CAD', big: false },
    { key: 'UNI', name: 'Another vehicle', sub: 'Standard ISO plug, no fascia kit', kit: null, code: '_UNI', big: false }
  ];
  var QUADLOCK = [
    { key: 'PQ', name: 'No large power pins', sub: 'Older PQ style plug', kit: 'DUDU7-KIT-T5.1PQ', code: '_T5.1PQ' },
    { key: 'MQB', name: 'Two large power pins', sub: 'Newer MQB style plug', kit: 'DUDU7-KIT-T5.1MQB', code: '_T5.1MQB' },
    { key: 'UNSURE', name: 'Not sure', sub: "We'll check with you before we send it", kit: 'DUDU7-KIT-T5.1PQ', code: '_T5.1PQ' }
  ];
  var SCREENS = [
    { key: 'OEM', name: '9-inch, factory style', sub: 'Standard VW size with touch buttons. Uses your original trims.', sku: null, code: '_OEM' },
    { key: '9.5', name: '9.5-inch full touch screen', sub: '', sku: 'DUDU7-SCR-9.5', code: '_9.5' },
    { key: '10.36', name: '10.36-inch full touch screen', sub: '', sku: 'DUDU7-SCR-10.36', code: '_10.36' },
    { key: '11.5', name: '11.5-inch screen', sub: '', sku: 'DUDU7-SCR-11.5', code: '_11.5' },
    { key: '13', name: '13-inch screen', sub: '', sku: 'DUDU7-SCR-13', code: '_13', bigOnly: true }
  ];
  var MEMORY = [
    { key: '8-128', name: '8GB memory, 128GB storage', sub: 'Intermediate to advanced use', sku: 'DUDU7-MEM-8-128', code: '_8/128' },
    { key: '12-256', name: '12GB memory, 256GB storage', sub: 'Intermediate to advanced use, extra storage', sku: 'DUDU7-MEM-12-256', code: '_12/256' },
    { key: '12-512', name: '12GB memory, 512GB storage', sub: 'Advanced use, maximum storage', sku: 'DUDU7-MEM-12-512', code: '_12/512' }
  ];
  var FITTING = [
    { key: 'SO', name: 'Delivered to you', sub: 'Posted to you to fit yourself.', sku: null, code: '_SO' },
    { key: 'EVW', name: 'Fitted at Everest VW', sub: 'Bring your van to our workshop in St Neots or Welford.', sku: 'DUDU7-FIT-EVW', code: '_FIT_EVW' },
    { key: 'UKM', name: 'Fitted at your address', sub: 'Anywhere on the UK mainland, not including Scotland. Plus travel at £1 a mile.', sku: 'DUDU7-FIT-UKM', code: '_FIT_UKM' }
  ];
  // Extras. "choices" are the priced variants; fit: true marks the fitted or installed version.
  var EXTRAS = [
    { group: 'Cameras', key: 'c360', name: '360 camera system', blurb: "Four cameras give you a bird's-eye view around the van, with recording.", icon: 'cam360',
      choices: [{ key: 'so', label: 'Supply only', sku: 'DUDU7-360-SO', code: '_360SO' }, { key: 'fit', label: 'Supplied and fitted, laser calibrated', sku: 'DUDU7-360-FF', code: '_360FF', fit: true }] },
    { group: 'Cameras', key: 'cal', name: '360 camera calibration', blurb: 'Laser calibration and set-up for a 360 system you already have or are fitting yourself.', icon: 'cam360', showIf: function (s) { return s.extras.c360 !== 'fit'; },
      choices: [{ key: 'evw', label: 'At our workshop (St Neots or Welford)', sku: 'DUDU7-360CAL-EVW', code: '360CAL_', fit: true }, { key: 'ukm', label: 'At your address, UK mainland, plus travel at £1 a mile', sku: 'DUDU7-360CAL-UKM', code: '360CALUKM_', fit: true }] },
    { group: 'Cameras', key: 'rc', name: 'Reversing camera, 1080p', blurb: 'HD rear view on your screen whenever you select reverse.', icon: 'camera', showIf: function (s) { return s.extras.c360 !== 'fit'; },
      choices: [{ key: 'so', label: 'Supply only', sku: 'DUDU7-RC-SO', code: '_SRC' }, { key: 'fit', label: 'Supplied and fitted', sku: 'DUDU7-RC-FIT', code: '_SFRC', fit: true }] },
    { group: 'Cameras', key: 'dvr', name: '2K dashcam', blurb: 'Sony 2K lens with lane and city safe assist.', icon: 'dashcam',
      choices: [{ key: 'so', label: 'Supply only', sku: 'DUDU7-DVR-SO', code: '_DVR2K_SO' }, { key: 'fit', label: 'Supplied and fitted', sku: 'DUDU7-DVR-FIT', code: '_DVR2K_FIT', fit: true }] },
    { group: 'On the road', key: 'dab', name: 'DAB+ digital radio', blurb: 'USB tuner with a stick-on aerial.', icon: 'radio',
      choices: [{ key: 'so', label: 'Supply only', sku: 'DUDU7-DAB-SO', code: '_DAB' }, { key: 'fit', label: 'Installed', sku: 'DUDU7-DAB-FIT', code: '_DABFIT', fit: true }] },
    { group: 'On the road', key: 'tpms', name: 'Tyre pressure monitoring', blurb: 'Pressure and temperature for every tyre, live on your screen.', icon: 'tyre',
      choices: [{ key: 'ext', label: 'External sensors (screw onto the valves)', sku: 'DUDU7-TPMS-EXT', code: '_TPE' }, { key: 'int', label: 'Internal sensors (fitted inside the tyres)', sku: 'DUDU7-TPMS-INT', code: '_TPI' }] },
    { group: 'On the road', key: 'mifi', name: '5G MiFi box and SIM', blurb: 'Your own 5G Wi-Fi in the van for maps, streaming and updates.', icon: 'wifi',
      choices: [{ key: 'yes', label: '5G MiFi box and SIM', sku: 'DUDU7-5GMIFI', code: '_5GMIFI' }] },
    { group: 'Controls and support', key: 'rem', name: 'Steering wheel remote', blurb: 'Programmable Bluetooth controller that mounts on the steering wheel.', icon: 'remote',
      choices: [{ key: 'so', label: 'Supply only', sku: 'DUDU7-REM-SO', code: '_SRCSO' }, { key: 'fit', label: 'Supplied and fitted', sku: 'DUDU7-REM-FIT', code: '_SRCF', fit: true }] },
    { group: 'Controls and support', key: 'hh', name: 'Handheld remote with keyboard', blurb: 'Air mouse and keyboard for typing and browsing on the screen.', icon: 'keyboard',
      choices: [{ key: 'yes', label: 'Handheld remote with keyboard', sku: 'DUDU7-HHREM', code: '_HHREM' }] },
    { group: 'Controls and support', key: 'sw', name: 'Software set-up support', blurb: 'An hour of our time setting up the software, apps and settings for you.', icon: 'support',
      choices: [{ key: 'yes', label: '1 hour of set-up support', sku: 'DUDU7-SW-1HR', code: '_SHR' }] }
  ];
  // Order used for the build code on the order (matches the old options app).
  var CODE_ORDER = ['c360', 'cal', 'rc', 'dvr', 'dab', 'mifi', 'tpms', 'rem', 'hh'];
  // Travel for fitting at your address: the price of the "Fitting travel" product (75p) per mile, one way, from our
  // base pin. Straight-line miles from postcodes.io times ROAD_FACTOR gets close to road miles.
  var BASE = { lat: 52.359019, lng: -0.67199 };
  var ROAD_FACTOR = 1.2;
  var BLOCKED_AREAS = ['AB', 'DD', 'DG', 'EH', 'FK', 'G', 'HS', 'IV', 'KA', 'KW', 'KY', 'ML', 'PA', 'PH', 'ZE', 'BT', 'IM', 'JE', 'GY'];
  var STEPS = [
    { n: 1, short: 'Vehicle', title: 'Your vehicle' },
    { n: 2, short: 'Screen', title: 'Screen and memory' },
    { n: 3, short: 'Fitting', title: 'Delivered or fitted?' },
    { n: 4, short: 'Extras', title: 'Cameras and extras' },
    { n: 5, short: 'Review', title: 'Review and add to basket' }
  ];

  // ---------- helpers ----------
  var fmt = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
  function money(p) { return fmt.format((p || 0) / 100); }
  function opt(sku) { return sku ? OPT[sku] : null; }
  function price(sku) { var o = opt(sku); return o ? o.price : 0; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function byKey(list, key) { for (var i = 0; i < list.length; i++) if (list[i].key === key) return list[i]; return null; }
  function priceTag(p, freeLabel) { return p > 0 ? '+' + money(p) : '<span class="is-free">' + (freeLabel || 'Included') + '</span>'; }

  var ICONS = {
    cam360: '<circle cx="12" cy="12" r="3.2"/><path d="M12 3v2.5M12 18.5V21M3 12h2.5M18.5 12H21M5.6 5.6l1.8 1.8M16.6 16.6l1.8 1.8M5.6 18.4l1.8-1.8M16.6 7.4l1.8-1.8"/>',
    camera: '<rect x="3" y="7" width="13" height="10" rx="2"/><path d="M16 10.5l5-3v9l-5-3"/>',
    dashcam: '<rect x="4" y="7" width="16" height="10" rx="2.5"/><circle cx="12" cy="12" r="3"/><path d="M8 4h8"/>',
    radio: '<rect x="3" y="8" width="18" height="12" rx="2"/><path d="M7 8l9-5"/><circle cx="15.5" cy="14" r="2.5"/><path d="M6 12.5h4M6 15.5h4"/>',
    tyre: '<circle cx="12" cy="12" r="8.5"/><circle cx="12" cy="12" r="4"/><path d="M12 3.5v4.5M12 16v4.5M3.5 12H8M16 12h4.5"/>',
    wifi: '<path d="M2.5 9a14 14 0 0 1 19 0M5.5 12.5a9.5 9.5 0 0 1 13 0M8.6 16a5 5 0 0 1 6.8 0"/><circle cx="12" cy="19" r="1"/>',
    remote: '<rect x="5" y="5" width="14" height="14" rx="4"/><circle cx="12" cy="12" r="2.6"/><path d="M12 7.5v1M12 15.5v1M7.5 12h1M15.5 12h1"/>',
    keyboard: '<rect x="2.5" y="6.5" width="19" height="11" rx="2"/><path d="M6 10h.01M9 10h.01M12 10h.01M15 10h.01M18 10h.01M7 14h10"/>',
    support: '<path d="M4 14v-2a8 8 0 0 1 16 0v2"/><rect x="3" y="13" width="4" height="6" rx="1.5"/><rect x="17" y="13" width="4" height="6" rx="1.5"/>'
  };
  function icon(name) {
    return '<span class="evb-add__ph" aria-hidden="true"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' + (ICONS[name] || ICONS.support) + '</svg></span>';
  }
  function thumb(x) {
    var img = null;
    for (var i = 0; i < x.choices.length && !img; i++) { var o = opt(x.choices[i].sku); if (o && o.image) img = o.image; }
    return img ? '<img class="evb-add__img" src="' + esc(img) + '" width="72" height="72" alt="" loading="lazy">' : icon(x.icon);
  }

  // ---------- state ----------
  var state = {
    open: 1,
    done: {},
    vehicle: '', quadlock: '', sos: '',
    screen: '', memory: '',
    fitting: '', postcode: '', pcOk: false, pcMsg: '', miles: null, pcBusy: false,
    extras: {},
    week: 'first', reg: '', notes: '',
    busy: false, error: ''
  };
  var buildRef = 'D7-' + Math.random().toString(36).slice(2, 7).toUpperCase();

  function veh() { return byKey(VEHICLES, state.vehicle); }
  function fitted() { return state.fitting === 'EVW' || state.fitting === 'UKM'; }
  function needsTravel() { return state.fitting === 'UKM' || state.extras.cal === 'ukm'; }
  function rateText() { return !CFG.travel ? '£1' : (CFG.travel.price < 100 ? CFG.travel.price + 'p' : money(CFG.travel.price)); }
  function milesText(n) { return n + (n === 1 ? ' mile' : ' miles'); }
  function travelOk() { return !needsTravel() || (state.pcOk && !state.pcBusy); }
  function kitFor() {
    var v = veh(); if (!v || !v.kit) return null;
    if (v.quadlock) { var q = byKey(QUADLOCK, state.quadlock); return q ? q : { kit: v.kit, code: v.code }; }
    return { kit: v.kit, code: v.code };
  }
  function screensFor() { var v = veh(); return SCREENS.filter(function (s) { return !s.bigOnly || (v && v.big); }); }

  // ---------- step validity ----------
  function stepOk(n) {
    var v = veh();
    if (n === 1) return !!v && (!v.quadlock || !!state.quadlock) && (!v.sos || !!state.sos);
    if (n === 2) return !!state.screen && !!state.memory && screensFor().some(function (s) { return s.key === state.screen; });
    if (n === 3) return !!state.fitting && (state.fitting !== 'UKM' || (state.pcOk && !state.pcBusy));
    if (n === 4) return travelOk();
    return true;
  }

  // ---------- lines and total ----------
  function lines() {
    var out = [];
    var v = veh();
    var X = window.EVB_EXTRA;
    if (X && X.lines) X.lines.forEach(function (l) { out.push({ title: l.title, sub: l.sub, price: l.price, ext: true }); });
    out.push({ title: 'DUDU7 head unit', sub: '', price: MAIN.price, id: MAIN.id, main: true });
    var k = kitFor();
    if (k && k.kit) out.push({ title: 'Fitting kit for your ' + (v ? v.name : 'vehicle'), price: price(k.kit), sku: k.kit });
    if (v && v.sos && state.sos === 'yes') out.push({ title: 'SOS eCall retention module', price: price('DUDU7-SOS'), sku: 'DUDU7-SOS' });
    var s = byKey(SCREENS, state.screen);
    if (s && s.sku) out.push({ title: 'Screen upgrade', sub: s.name, price: price(s.sku), sku: s.sku });
    var m = byKey(MEMORY, state.memory);
    if (m) out.push({ title: 'Memory and storage', sub: m.name, price: price(m.sku), sku: m.sku });
    var f = byKey(FITTING, state.fitting);
    if (f && f.sku) out.push({ title: f.name, price: price(f.sku), sku: f.sku });
    EXTRAS.forEach(function (x) {
      var c = activeChoice(x); if (!c) return;
      out.push({ title: x.name, sub: x.choices.length > 1 ? c.label : '', price: price(c.sku), sku: c.sku });
    });
    if (needsTravel() && state.miles && CFG.travel) out.push({ title: 'Travel to you', sub: milesText(state.miles) + ' from our base at ' + rateText() + ' a mile', price: state.miles * CFG.travel.price, travel: true });
    return out;
  }
  function activeChoice(x) {
    if (x.showIf && !x.showIf(state)) return null;
    var key = state.extras[x.key]; if (!key) return null;
    return byKey(x.choices, key);
  }
  function total() { return lines().reduce(function (t, l) { return t + (l.price || 0); }, 0); }
  function fromPrice() {
    var minMem = MEMORY.reduce(function (m, x) { var p = price(x.sku); return m === null || p < m ? p : m; }, null) || 0;
    return MAIN.price + minMem;
  }
  function buildCode() {
    var parts = [MAIN.sku || 'DUDU7'];
    var k = kitFor(); var v = veh();
    if (v) parts.push(k && k.code ? k.code : v.code);
    if (v && v.sos && state.sos === 'yes') parts.push('_SOS');
    var f = byKey(FITTING, state.fitting); if (f) parts.push(f.code);
    var s = byKey(SCREENS, state.screen); if (s) parts.push(s.code);
    var m = byKey(MEMORY, state.memory); if (m) parts.push(m.code);
    var sw = activeChoice(byKey(EXTRAS, 'sw')); if (sw) parts.push(sw.code);
    CODE_ORDER.forEach(function (key) { var c = activeChoice(byKey(EXTRAS, key)); if (c) parts.push(c.code); });
    return parts.join('-');
  }

  // ---------- weeks ----------
  var WEEKS = [{ key: 'first', label: 'First available slot' }];
  (function () {
    var d = new Date(); d.setHours(12, 0, 0, 0); d.setDate(d.getDate() + 7);
    while (d.getDay() !== 1) d.setDate(d.getDate() + 1);
    for (var i = 0; i < 8; i++) {
      WEEKS.push({ key: d.toISOString().slice(0, 10), label: 'Week starting Monday ' + d.getDate() + ' ' + d.toLocaleDateString('en-GB', { month: 'long' }) });
      d.setDate(d.getDate() + 7);
    }
  })();
  function weekLabel() { var w = byKey(WEEKS, state.week) || WEEKS[0]; return w.label; }

  // ---------- postcode ----------
  function checkPostcode(raw) {
    var pc = String(raw || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    state.postcode = pc.length > 3 ? pc.slice(0, -3) + ' ' + pc.slice(-3) : pc;
    state.pcOk = false; state.pcMsg = ''; state.miles = null; state.pcBusy = false;
    if (!pc) return;
    var m = pc.match(/^([A-Z]{1,2})(\d[A-Z\d]?)(\d[A-Z]{2})$/);
    if (!m) { state.pcMsg = 'Please check your postcode, for example PE19 1AE.'; return; }
    var area = m[1], district = parseInt(m[2], 10);
    var blocked = BLOCKED_AREAS.indexOf(area) > -1 || (area === 'TD' && district !== 15) ||
      (area === 'TR' && district >= 21 && district <= 25) || (area === 'PO' && district >= 30 && district <= 41) ||
      (area === 'KA' && district === 27) || (area === 'PA' && district >= 20);
    if (blocked) {
      state.pcMsg = "We can't fit at your address there. Choose delivery or fitting at our workshop in St Neots or Welford, or call us on " + CFG.phone + '.';
      state.pcBlocked = true;
      return;
    }
    state.pcBlocked = false;
    state.pcOk = true;
    lookupMiles(pc);
  }
  // Distance from our base, via postcodes.io (free, no key). If the lookup can't be reached the order still goes
  // through and the travel is marked "To confirm".
  var milesCache = {};
  function lookupMiles(pc) {
    if (milesCache[pc]) { state.miles = milesCache[pc]; return; }
    state.pcBusy = true;
    fetch('https://api.postcodes.io/postcodes/' + encodeURIComponent(pc))
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (state.postcode.replace(' ', '') !== pc) return;
        state.pcBusy = false;
        if (!j || j.status !== 200 || !j.result || j.result.latitude == null) {
          state.pcOk = false;
          state.pcMsg = "We couldn't find that postcode. Please check it, or call us on " + CFG.phone + '.';
        } else {
          state.miles = milesCache[pc] = roadMiles(j.result.latitude, j.result.longitude);
        }
        render();
      })
      .catch(function () {
        if (state.postcode.replace(' ', '') !== pc) return;
        state.pcBusy = false;
        render();
      });
  }
  function roadMiles(lat, lng) {
    var R = 3958.8, rad = Math.PI / 180;
    var dLat = (lat - BASE.lat) * rad, dLng = (lng - BASE.lng) * rad;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(BASE.lat * rad) * Math.cos(lat * rad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return Math.max(1, Math.ceil(2 * R * Math.asin(Math.sqrt(a)) * ROAD_FACTOR));
  }

  // ---------- render: static skeleton ----------
  function optCard(name, value, item, priceHtml, checked, disabled) {
    return '<label class="evb-opt"><input type="radio" name="' + name + '" value="' + esc(value) + '"' + (checked ? ' checked' : '') + (disabled ? ' disabled' : '') + '>' +
      '<span class="evb-opt__card"><span class="evb-opt__top"><span class="evb-opt__radio" aria-hidden="true"></span>' +
      '<span class="evb-opt__name">' + esc(item.name) + (item.sub ? '<small>' + esc(item.sub) + '</small>' : '') + '</span>' +
      '<span class="evb-opt__price' + (priceHtml.indexOf('is-free') > -1 ? ' is-free' : '') + '">' + priceHtml + '</span></span></span></label>';
  }
  function stepShell(s, body) {
    return '<section class="evb-step" data-step="' + s.n + '" aria-labelledby="evb-s' + s.n + '">' +
      '<button type="button" class="evb-step__head" data-edit="' + s.n + '" id="evb-s' + s.n + '">' +
      '<span class="evb-step__num"><span>' + s.n + '</span></span><span class="evb-step__title">' + esc(s.title) + '</span>' +
      '<span class="evb-step__summary" data-summary="' + s.n + '"></span><span class="evb-step__edit">Change</span></button>' +
      '<div class="evb-step__body">' + body + '</div></section>';
  }
  var CHECK = '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M2 6.2l2.5 2.5L10 3.2" fill="none" stroke="#fff" stroke-width="2"/></svg>';

  function build() {
    $('[data-evb-from]').textContent = money(fromPrice());
    $('[data-evb-progress]').innerHTML = STEPS.map(function (s) { return '<li data-dot="' + s.n + '">' + s.short + '</li>'; }).join('');

    if (!CFG.ready) {
      $('[data-evb-steps]').innerHTML = '<div class="evb-step__body" style="display:block;padding-top:16px"><p class="evb-note evb-note--warn">The build options are not set up yet. Call us on ' + esc(CFG.phone) + " and we'll put your order together.</p></div>";
      return;
    }

    var s1 = '<fieldset class="evb-q"><legend>Which vehicle is it for?</legend>' +
      '<p class="evb-q__help">This sets the fitting kit and the screen sizes that fit.</p>' +
      '<div class="evb-opts evb-opts--2">' + VEHICLES.map(function (v) {
        return optCard('evb-vehicle', v.key, v, v.kit ? priceTag(price(v.kit)) : '<span class="is-free">No kit</span>');
      }).join('') + '</div></fieldset>' +
      '<div class="evb-sub" data-show="quadlock" hidden><fieldset class="evb-q"><legend>Check the plug behind your current radio</legend>' +
      '<p class="evb-q__help">The large square quadlock plug either has two large power pins or none. It tells us which T5.1 kit you need.</p>' +
      '<div class="evb-opts">' + QUADLOCK.map(function (q) { return optCard('evb-quadlock', q.key, q, ''); }).join('') + '</div></fieldset></div>' +
      '<div class="evb-sub" data-show="sos" hidden><fieldset class="evb-q"><legend>SOS eCall retention module</legend>' +
      '<p class="evb-q__help">Keeps your van’s factory SOS emergency call working with the new unit. Only needed if your van has the SOS button.</p>' +
      '<div class="evb-opts">' + optCard('evb-sos', 'no', { name: 'Not needed' }, '<span class="is-free">No charge</span>') +
      optCard('evb-sos', 'yes', { name: 'Add the SOS module' }, priceTag(price('DUDU7-SOS'))) + '</div></fieldset></div>' +
      '<button type="button" class="evb-btn evb-btn--primary" data-next="1" disabled>Continue</button>';

    var s2 = '<fieldset class="evb-q"><legend>Screen size</legend><div class="evb-opts" data-screens>' +
      SCREENS.map(function (s) { return '<div data-screen-wrap="' + esc(s.key) + '">' + optCard('evb-screen', s.key, s, s.sku ? priceTag(price(s.sku)) : '<span class="is-free">Included</span>') + '</div>'; }).join('') +
      '</div></fieldset>' +
      '<fieldset class="evb-q"><legend>Memory and storage</legend><p class="evb-q__help">More memory keeps apps quick with several open at once. More storage holds offline maps, music and video.</p><div class="evb-opts">' +
      MEMORY.map(function (m) { return optCard('evb-memory', m.key, m, '+' + money(price(m.sku))); }).join('') + '</div></fieldset>' +
      '<button type="button" class="evb-btn evb-btn--primary" data-next="2" disabled>Continue</button>';

    var s3 = '<fieldset class="evb-q"><legend class="sr-only">How would you like your DUDU7?</legend><div class="evb-opts">' +
      FITTING.map(function (f) { return optCard('evb-fitting', f.key, f, f.sku ? priceTag(price(f.sku)) : '<span class="is-free">No charge</span>'); }).join('') + '</div></fieldset>' +
      '<div class="evb-sub" data-show="postcode" hidden><div class="evb-field"><label for="evb-postcode">Your postcode</label>' +
      '<input id="evb-postcode" name="evb-postcode" autocomplete="postal-code" placeholder="e.g. PE19 1AE" maxlength="9" data-upper data-postcode>' +
      '<small data-pc-msg>We use this to check we can reach you and to plan the visit.</small></div></div>' +
      '<button type="button" class="evb-btn evb-btn--primary" data-next="3" disabled>Continue</button>';

    var groups = [];
    EXTRAS.forEach(function (x) { if (groups.indexOf(x.group) < 0) groups.push(x.group); });
    var s4 = '<p class="evb-step__intro">All optional. Tick anything you want with your DUDU7.</p>' + groups.map(function (g) {
      return '<div class="evb-group"><p class="evb-group__title">' + esc(g) + '</p><div class="evb-adds">' + EXTRAS.filter(function (x) { return x.group === g; }).map(function (x) {
        var single = x.choices.length === 1;
        var minP = x.choices.reduce(function (m, c) { var p = price(c.sku); return m === null || p < m ? p : m; }, null);
        return '<div class="evb-add" data-extra="' + x.key + '"><label class="evb-add__main"><input type="checkbox" value="' + x.key + '" data-extra-toggle>' +
          '<span class="evb-add__box" aria-hidden="true">' + CHECK + '</span>' + thumb(x) +
          '<span class="evb-add__text"><span class="evb-add__name">' + esc(x.name) + '</span><span class="evb-add__blurb">' + esc(x.blurb) + '</span></span>' +
          '<span class="evb-add__price" data-extra-price>' + (single ? money(minP) : '<small>from</small>' + money(minP)) + '</span></label>' +
          (single ? '' : '<div class="evb-add__opts" data-extra-opts hidden>' + x.choices.map(function (c) {
            return '<label><input type="radio" name="evb-x-' + x.key + '" value="' + c.key + '"><span>' + esc(c.label) + '</span><b>' + money(price(c.sku)) + '</b></label>';
          }).join('') + '</div>') + '</div>';
      }).join('') + '</div></div>';
    }).join('') +
      '<div class="evb-sub" data-show="calpc" hidden><div class="evb-field"><label for="evb-postcode2">Your postcode for the calibration visit</label>' +
      '<input id="evb-postcode2" autocomplete="postal-code" placeholder="e.g. PE19 1AE" maxlength="9" data-upper data-postcode><small data-pc-msg></small></div></div>' +
      '<button type="button" class="evb-btn evb-btn--primary" data-next="4">Continue</button>';

    var s5 = '<div class="evb-fields">' +
      '<div class="evb-field" data-show="week" hidden><label for="evb-week">Preferred week for fitting</label><select id="evb-week" data-week>' +
      WEEKS.map(function (w) { return '<option value="' + w.key + '">' + esc(w.label) + '</option>'; }).join('') +
      '</select><small>We’ll be in touch to confirm the exact day.</small></div>' +
      '<div class="evb-field"><label for="evb-reg">Vehicle registration <span>(optional)</span></label><input id="evb-reg" autocomplete="off" placeholder="e.g. AB21 CDE" maxlength="10" data-upper data-reg><small>Helps us check your exact spec before we send or fit anything.</small></div>' +
      '<div class="evb-field"><label for="evb-notes">Anything we should know? <span>(optional)</span></label><textarea id="evb-notes" rows="2" maxlength="400" placeholder="e.g. camper conversion, aftermarket parts already fitted" data-notes></textarea></div>' +
      '</div>' +
      '<div class="evb-sum"><h3>Your DUDU7 build</h3><ul class="evb-sum__lines" data-lines></ul>' +
      '<div class="evb-sum__total"><span>Total</span><b data-total-big></b></div><p class="evb-sum__save" data-save></p></div>' +
      '<p class="evb-error" data-error role="alert" hidden></p>' +
      '<button type="button" class="evb-btn evb-btn--primary evb-btn--big" data-add>Add to basket</button>' +
      '<ul class="evb-trust"><li>Secure checkout</li><li>UK support from our team</li><li>Every part shown on your order</li></ul>';

    $('[data-evb-steps]').innerHTML = stepShell(STEPS[0], s1) + stepShell(STEPS[1], s2) + stepShell(STEPS[2], s3) + stepShell(STEPS[3], s4) + stepShell(STEPS[4], s5);
    bind();
  }

  // ---------- events ----------
  function bind() {
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name === 'evb-vehicle') {
        state.vehicle = t.value; state.quadlock = ''; state.sos = '';
        $$('input[name="evb-quadlock"], input[name="evb-sos"]').forEach(function (i) { i.checked = false; });
        if (!screensFor().some(function (s) { return s.key === state.screen; })) { state.screen = ''; $$('input[name="evb-screen"]').forEach(function (i) { i.checked = false; }); }
      }
      if (t.name === 'evb-quadlock') state.quadlock = t.value;
      if (t.name === 'evb-sos') state.sos = t.value;
      if (t.name === 'evb-screen') state.screen = t.value;
      if (t.name === 'evb-memory') state.memory = t.value;
      if (t.name === 'evb-fitting') { state.fitting = t.value; retuneExtras(); }
      if (t.hasAttribute('data-extra-toggle')) {
        var x = byKey(EXTRAS, t.value);
        if (t.checked) {
          var pick = x.choices[0];
          if (x.choices.length > 1 && fitted()) { for (var i = 0; i < x.choices.length; i++) if (x.choices[i].fit) { pick = x.choices[i]; break; } }
          state.extras[x.key] = pick.key;
        } else { delete state.extras[x.key]; }
      }
      if (t.name && t.name.indexOf('evb-x-') === 0) state.extras[t.name.slice(6)] = t.value;
      if (t.hasAttribute('data-week')) state.week = t.value;
      render();
    });
    root.addEventListener('input', function (e) {
      var t = e.target;
      if (t.hasAttribute('data-postcode')) { checkPostcode(t.value); render(); }
      if (t.hasAttribute('data-reg')) state.reg = t.value.trim().toUpperCase();
      if (t.hasAttribute('data-notes')) state.notes = t.value.trim();
    });
    root.addEventListener('click', function (e) {
      var next = e.target.closest('[data-next]');
      if (next && !next.disabled) { var n = +next.getAttribute('data-next'); state.done[n] = true; openStep(firstOpenAfter(n)); return; }
      var edit = e.target.closest('[data-edit]');
      if (edit) { var m = +edit.getAttribute('data-edit'); if (state.done[m] || m === state.open) { openStep(m); } return; }
      if (e.target.closest('[data-add]')) addToBasket();
      if (e.target.closest('[data-evb-mbar-btn]')) mbarAction();
    });
  }
  // When the fitting choice changes, move ticked extras to the matching supply or fitted version.
  function retuneExtras() {
    EXTRAS.forEach(function (x) {
      if (!state.extras[x.key] || x.choices.length < 2) return;
      var cur = byKey(x.choices, state.extras[x.key]);
      if (!cur || x.key === 'tpms' || x.key === 'cal') return;
      var want = null;
      for (var i = 0; i < x.choices.length; i++) if (!!x.choices[i].fit === fitted()) { want = x.choices[i]; break; }
      if (want) state.extras[x.key] = want.key;
    });
  }
  function firstOpenAfter(n) {
    for (var i = n + 1; i <= STEPS.length; i++) { if (!state.done[i] || !stepOk(i)) return i; }
    return STEPS.length;
  }
  function openStep(n) {
    for (var i = 1; i < n; i++) if (!stepOk(i)) { n = i; break; }
    state.open = n;
    render();
    var el = $('[data-step="' + n + '"]');
    if (el && el.getBoundingClientRect().top < 70) el.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  }
  function mbarAction() {
    if (state.open === 5) { addToBasket(); return; }
    var el = $('[data-step="' + state.open + '"]');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ---------- render: state ----------
  function render() {
    var v = veh();
    // Invalidate later steps if an earlier one is no longer complete.
    for (var i = 1; i <= 3; i++) if (!stepOk(i)) { for (var j = i; j <= 5; j++) delete state.done[j]; if (state.open > i) state.open = i; break; }

    $$('.evb-step').forEach(function (el) {
      var n = +el.getAttribute('data-step');
      el.classList.toggle('is-open', n === state.open);
      el.classList.toggle('is-done', !!state.done[n] && n !== state.open);
      var head = el.querySelector('.evb-step__head');
      head.setAttribute('aria-expanded', n === state.open ? 'true' : 'false');
      head.disabled = !(state.done[n] || n === state.open);
    });
    $$('[data-dot]').forEach(function (d) {
      var n = +d.getAttribute('data-dot');
      d.classList.toggle('is-open', n === state.open);
      d.classList.toggle('is-done', !!state.done[n] && n !== state.open);
    });

    // Step 1
    $('[data-show="quadlock"]').hidden = !(v && v.quadlock);
    $('[data-show="sos"]').hidden = !(v && v.sos);
    $('[data-next="1"]').disabled = !stepOk(1);
    // Step 2
    $$('[data-screen-wrap]').forEach(function (w) {
      var s = byKey(SCREENS, w.getAttribute('data-screen-wrap'));
      w.hidden = !!s.bigOnly && !(v && v.big);
    });
    $('[data-next="2"]').disabled = !stepOk(2);
    // Step 3
    var pcBox = $('[data-show="postcode"]');
    pcBox.hidden = state.fitting !== 'UKM';
    var rate = rateText();
    var pcText = state.pcMsg || (state.pcBusy ? 'Checking your postcode…' : (state.pcOk ?
      (state.miles && CFG.travel ? 'Great, we can come to you. You are about ' + milesText(state.miles) + ' from our base, so travel is ' + money(state.miles * CFG.travel.price) + ' (' + rate + ' a mile).' : "Great, we can come to you. We'll confirm the travel cost with you.") :
      'We use this to work out your travel cost (' + rate + ' a mile from our base) and plan the visit.'));
    $$('[data-pc-msg]').forEach(function (el) { el.textContent = pcText; el.style.color = state.pcMsg ? '#a32121' : (state.pcOk && !state.pcBusy ? 'var(--evb-good)' : ''); });
    $('[data-next="3"]').disabled = !stepOk(3);
    // Step 4
    EXTRAS.forEach(function (x) {
      var card = $('[data-extra="' + x.key + '"]');
      var shown = !x.showIf || x.showIf(state);
      card.hidden = !shown;
      var on = shown && !!state.extras[x.key];
      card.classList.toggle('is-on', on);
      card.querySelector('[data-extra-toggle]').checked = on;
      var opts = card.querySelector('[data-extra-opts]');
      if (opts) {
        opts.hidden = !on;
        $$('input', opts).forEach(function (r) { r.checked = on && r.value === state.extras[x.key]; });
      }
    });
    var nExtras = EXTRAS.filter(function (x) { return !!activeChoice(x); }).length;
    $('[data-next="4"]').textContent = nExtras ? 'Continue with ' + nExtras + (nExtras === 1 ? ' extra' : ' extras') : 'Continue without extras';
    $('[data-show="calpc"]').hidden = !(state.extras.cal === 'ukm' && state.fitting !== 'UKM');
    $('[data-next="4"]').disabled = !stepOk(4);
    $$('[data-postcode]').forEach(function (i) { if (i !== document.activeElement && i.value !== state.postcode) i.value = state.postcode; });
    // Step 5
    $('[data-show="week"]').hidden = !fitted();

    // Summaries
    var q = byKey(QUADLOCK, state.quadlock);
    setSummary(1, v ? v.name + (q && q.key !== 'UNSURE' ? ', ' + (q.key === 'MQB' ? 'MQB plug' : 'PQ plug') : '') + (state.sos === 'yes' ? ', SOS module' : '') : '');
    var sc = byKey(SCREENS, state.screen), mm = byKey(MEMORY, state.memory);
    setSummary(2, sc && mm ? sc.name.split(',')[0].replace(' full touch screen', '').replace(' screen', '') + ', ' + mm.name.replace(' memory, ', ' / ').replace(' storage', '') : '');
    var fi = byKey(FITTING, state.fitting);
    setSummary(3, fi ? fi.name + (state.fitting === 'UKM' && state.postcode ? ' (' + state.postcode + ')' : '') : '');
    setSummary(4, state.done[4] ? (nExtras ? nExtras + (nExtras === 1 ? ' extra' : ' extras') : 'No extras') : '');

    // Totals
    var t = total();
    var started = !!state.vehicle;
    $('[data-evb-total]').textContent = money(started ? t : fromPrice());
    $('[data-evb-total-m]').textContent = money(started ? t : fromPrice());
    $('[data-lines]').innerHTML = lines().map(function (l) {
      return '<li><span>' + esc(l.title) + (l.sub ? '<small>' + esc(l.sub) + '</small>' : '') + '</span><b>' + money(l.price) + '</b></li>';
    }).join('');
    $('[data-total-big]').textContent = money(t);
    var save = MAIN.compareAt > MAIN.price ? MAIN.compareAt - MAIN.price : 0;
    $('[data-save]').textContent = save ? 'Includes ' + money(save) + ' off the head unit' : '';
    var err = $('[data-error]'); err.hidden = !state.error; err.textContent = state.error;
    var add = $('[data-add]');
    add.disabled = state.busy || !(stepOk(1) && stepOk(2) && stepOk(3) && stepOk(4));
    add.innerHTML = state.busy ? '<span class="evb-btn__spin" aria-hidden="true"></span> Adding' : 'Add to basket';
    var mb = $('[data-evb-mbar-btn]');
    mb.textContent = state.open === 5 ? 'Add to basket' : 'Continue';
    mb.disabled = state.open === 5 && add.disabled;
  }
  function setSummary(n, text) { var el = $('[data-summary="' + n + '"]'); if (el) el.textContent = state.done[n] || n < state.open ? text : ''; }

  // ---------- basket ----------
  function addToBasket() {
    if (state.busy || !(stepOk(1) && stepOk(2) && stepOk(3) && stepOk(4))) return;
    var v = veh();
    var q = byKey(QUADLOCK, state.quadlock);
    var props = { Vehicle: v.name };
    if (v.quadlock && q) props['Radio plug'] = q.key === 'UNSURE' ? 'Not sure, please check' : q.name + ' (' + q.key + ')';
    if (v.sos) props['SOS module'] = state.sos === 'yes' ? 'Yes' : 'No';
    props.Screen = byKey(SCREENS, state.screen).name;
    props.Memory = byKey(MEMORY, state.memory).name;
    props.Fitting = byKey(FITTING, state.fitting).name;
    if (needsTravel()) { props.Postcode = state.postcode; props.Travel = state.miles ? milesText(state.miles) + ' from our base' : 'To confirm'; }
    if (fitted()) props['Preferred week'] = weekLabel();
    if (state.reg) props.Registration = state.reg;
    if (state.notes) props.Notes = state.notes;
    props['Build ref'] = buildRef;
    props.SKU = buildCode();
    props._build = buildRef;

    var items = lines().filter(function (l) { return !l.ext; }).map(function (l) {
      if (l.main) return { id: MAIN.id, quantity: 1, properties: props };
      if (l.travel) return { id: CFG.travel.id, quantity: state.miles, properties: { 'Build ref': buildRef, _build: buildRef } };
      var o = opt(l.sku);
      return { id: o.id, quantity: 1, properties: { 'Build ref': buildRef, _build: buildRef } };
    });

    // Lines passed in by the van funnel (a DigiDash) go in the same basket add as their own lines (no build tag, so the drawer keeps them separate).
    if (window.EVB_EXTRA && window.EVB_EXTRA.items && window.EVB_EXTRA.items.length) {
      items = window.EVB_EXTRA.items.map(function (it) {
        return { id: it.id, quantity: it.quantity || 1, properties: Object.assign({}, it.properties) };
      }).concat(items);
    }
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer && typeof drawer.renderContents === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    state.busy = true; state.error = ''; render();
    var cartAdd = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    fetch(cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        state.busy = false;
        if (!res.ok || res.j.status) { state.error = (res.j && (res.j.description || res.j.message)) || 'Something went wrong adding your build. Please try again or call us.'; render(); return; }
        buildRef = 'D7-' + Math.random().toString(36).slice(2, 7).toUpperCase();
        render();
        if (drawer && res.j.sections) {
          if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          drawer.renderContents(Object.assign({ id: MAIN.id }, res.j));
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'evb-dudu7', productVariantId: MAIN.id, cartData: res.j }); } catch (e) {}
        }
      })
      .catch(function () { state.busy = false; state.error = 'We couldn’t reach the basket. Check your connection and try again.'; render(); });
  }

  // ---------- mobile bar ----------
  function watchBar() {
    var bar = $('[data-evb-mbar]'), card = $('[data-evb-card]');
    if (!('IntersectionObserver' in window) || !bar || !card) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { bar.classList.toggle('is-on', en.isIntersecting); });
    }, { rootMargin: '0px 0px -40% 0px' }).observe(card);
  }

  build();
  if (CFG.ready) { render(); watchBar(); }

  // Lets another part of the page (the van funnel) pick the vehicle and refresh the totals.
  window.EVB = {
    setVehicle: function (key, reg) {
      if (!CFG.ready) return;
      if (reg) { state.reg = String(reg).toUpperCase(); var ri = $('[data-reg]'); if (ri) ri.value = state.reg; }
      var input = $('input[name="evb-vehicle"][value="' + key + '"]');
      if (!input) return;
      if (state.vehicle !== key) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
      if (stepOk(1)) { state.done[1] = true; openStep(firstOpenAfter(1)); } else { openStep(1); }
    },
    refresh: function () { if (CFG.ready) render(); }
  };
})();
